import { getSiteStats } from "../../utils/stats";

export const getStatsSchema = () => {
  const { cities, categories, places } = getSiteStats();

  return {
    "@context": "https://schema.org",
    "@type": "Dataset",
    name: "NearbyGuide Places Dataset",
    description:
      "A curated dataset of trusted places across major Indian cities.",
    url: "https://nearbyguide.in/",
    creator: {
      "@type": "Organization",
      name: "NearbyGuide",
      url: "https://nearbyguide.in/",
    },
    spatialCoverage: {
      "@type": "AdministrativeArea",
      name: "India",
    },
    variableMeasured: [
      {
        "@type": "PropertyValue",
        name: "Cities Covered",
        value: cities,
      },
      {
        "@type": "PropertyValue",
        name: "Categories",
        value: categories,
      },
      {
        "@type": "PropertyValue",
        name: "Places Listed",
        value: places,
      },
    ],
  };
};
